import { FiHome, FiUsers, FiBook, FiClipboard } from 'react-icons/fi';

export const LinkItems = [
  { name: 'Escritorio', icon: FiHome, link: '/plataforma/profesores' },
  { name: 'Preguntas', icon: FiClipboard, link: '/plataforma/profesores/preguntas' },
  { name: 'Actividades', icon: FiBook, link: '/plataforma/profesores/actividades' },
  { name: 'Asistencias', icon: FiUsers, link: '/plataforma/profesores/asistencias' },
  { name: 'Listas', icon: FiUsers, link: '/plataforma/profesores/filtro-students' },
];
